<template>
  <div>
    <div class="form-content">
      <el-form
        ref="formDataRef"
        :model="form"
        label-position="top"
        size="small"
        :disabled="formType === 1"
      >
        <!--基础配置-->
        <el-card class="mb10">
          <template slot="header">
            <div class="card-title">
              <span class="card-title-text">{{ $t('mdfeTranslate.BasicConfiguration') }}</span>
            </div>
          </template>
          <el-row :gutter="10">
            <el-col :span="24">
              <!--航空公司名称-->
              <el-form-item
                :label="$t('mdfeTranslate.AirlineName')"
                prop="basicConfig.airlineName"
                :rules="[
                  { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur','change']}
                ]"
              >
                <el-input

                  v-model="form.basicConfig.airlineName"
                  :placeholder="$t('GlobalSetObj.pleaseInput')"
                  clearable
                  maxlength="100"
                  show-word-limit
                />
                <span style="font-size: 12px">{{ $t('mdfeTranslate.IdentifyTheAirlineToWhichTheConfigurationBelongs') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <!--API环境URL-->
              <el-form-item
                :label="$t('mdfeTranslate.APIEnvironmentURL')"
                prop="basicConfig.baseUrl"
                :rules="[
                  { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur','change']}
                ]"
              >
                <el-input
                  v-model="form.basicConfig.baseUrl"
                  :placeholder="$t('GlobalSetObj.pleaseInput')"
                  clearable
                  maxlength="100"
                  show-word-limit
                />
                <span style="font-size: 12px">{{ $t('mdfeTranslate.ProductionEnvironmentAPIBaseAddress') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <!--登录邮箱-->
              <el-form-item
                :label="$t('mdfeTranslate.LoginEmail')"
                prop="basicConfig.email"
                :rules="[
                  { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur','change']},
                  {
                    pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: $t('collectionCenter.emailNotFormat'),
                    trigger: ['blur','change']
                  }
                ]"
              >
                <el-input
                  v-model="form.basicConfig.email"
                  :placeholder="$t('GlobalSetObj.pleaseInput')"
                  clearable
                  maxlength="50"
                  show-word-limit
                />
                <span style="font-size: 12px">{{ $t('mdfeTranslate.AzulCargoProvidedAPIAuthenticationEmail') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <!--登录密码-->
              <!--              {-->
              <!--              pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*]).{8,}$/,-->
              <!--              message: $t('mdfeTranslate.ThePasswordMustBeComposedOf8To16Characters'),-->
              <!--              trigger: ['blur','change']-->
              <!--              }-->
              <el-form-item
                :label="$t('mdfeTranslate.LoginPassword')"
                prop="basicConfig.senha"
                :rules="[
                  { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur','change']}
                ]"
              >
                <el-input
                  v-model="form.basicConfig.senha"
                  type="password"
                  autocomplete="new-password"
                  clearable
                  show-password
                  minlength="8"
                  show-word-limit
                  :placeholder="$t('GlobalSetObj.pleaseInput')"
                />
                <span style="font-size: 12px">{{ $t('mdfeTranslate.AuthenticationPasswordUsedWithEmail') }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <!--运输参数-->
        <el-card>
          <template slot="header">
            <div class="card-title">
              <span class="card-title-text">{{ $t('mdfeTranslate.TransportationParameters') }}</span>
            </div>
          </template>
          <el-row :gutter="10">
            <el-col :span="24">
              <!--支付方式-->
              <el-form-item
                :label="$t('compensationManagement.PaymentMethod')"
                prop="transportConfig.formaPagamento"
                :rules="[
                  { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur','change']}
                ]"
              >
                <el-select
                  v-model="form.transportConfig.formaPagamento"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  style="width: 100%"
                  clearable
                  filterable
                  @change="changeFormaPagamento(form.transportConfig.formaPagamento)"
                >
                  <!--发货方在起运地支付-->
                  <el-option key="1" :label="'PP-' + $t('mdfeTranslate.TheSenderPaysTheShippingFeeAtTheOrigin')" value="PP" />
                  <!--收货方在目的地支付-->
                  <el-option key="2" :label="'CC-' + $t('mdfeTranslate.TheReceiverPaysTheShippingFeeAtTheDestination')" value="CC" />
                  <!--通过支票账户支付-->
                  <el-option key="3" :label="'PX-' + $t('mdfeTranslate.PayByCheckAccount')" value="PX" />
                </el-select>
                <span style="font-size: 12px">{{ $t('mdfeTranslate.DecideWhoPaysTheShippingFee') }}</span>
              </el-form-item>
            </el-col>
            <el-col v-if="form.transportConfig.formaPagamento === 'PX'" :span="24">
              <!--银行账户-->
              <el-form-item
                :label="$t('GlobalSetObj.bankAccount1') + 'CNPJ'"
                prop="transportConfig.contaCorrente"
                :rules="[
                  { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur','change']},
                  {
                    pattern: /^([0-9A-Za-z]{9}\d{2}|[0-9A-Za-z]{12}\d{2}|[0-9A-Za-z]{3}\.[0-9A-Za-z]{3}\.[0-9A-Za-z]{3}-\d{2}|[0-9A-Za-z]{2}\.[0-9A-Za-z]{3}\.[0-9A-Za-z]{3}\/[0-9A-Za-z]{4}-\d{2})$/,
                    message: $t('mdfeTranslate.PleaseEnterTheCorrectCNPJ'),
                    trigger: ['blur','change']
                  }
                ]"
              >
                <el-input
                  v-model="form.transportConfig.contaCorrente"
                  :placeholder="$t('GlobalSetObj.pleaseInput')"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <!--交付类型-->
              <el-form-item
                :label="$t('mdfeTranslate.DeliveryType')"
                prop="transportConfig.tipoEntrega"
                :rules="[
                  { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur','change']}
                ]"
              >
                <el-select
                  v-model="form.transportConfig.tipoEntrega"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  style="width: 100%"
                  filterable clearable
                >
                  <!--收货人到机场自提-->
                  <el-option key="1" :label="'Aeroporto-' + $t('mdfeTranslate.ReceiverPickupAtAirport')" value="Aeroporto" />
                  <!--送货上门-->
                  <el-option key="2" :label="'Domicilio-' + $t('mdfeTranslate.DeliveryToDoor')" value="Domicilio" />
                </el-select>
                <span style="font-size: 12px">{{ $t('mdfeTranslate.DeliveryMethodForGoodsCurrently') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <!--服务代码-->
              <el-form-item
                :label="$t('mdfeTranslate.ServiceCode')"
                prop="transportConfig.siglaServico"
                :rules="[
                  { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur','change']}
                ]"
              >
                <el-select
                  v-model="form.transportConfig.siglaServico"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  style="width: 100%"
                  clearable filterable
                >
                  <el-option key="1" label="PREMIUM" value="PREMIUM" />
                  <el-option key="2" label="PREMIUM_CORP" value="PREMIUM_CORP" />
                  <el-option key="3" label="EXPRESSO" value="EXPRESSO" />
                  <el-option key="4" label="EXPRESSO_CORP" value="EXPRESSO_CORP" />
                  <el-option key="5" label="ECOMM" value="ECOMM" />
                  <el-option key="6" label="ECOMM_CORP" value="ECOMM_CORP" />
                  <el-option key="7" label="STANDARD" value="STANDARD" />
                  <el-option key="8" label="STANDARD_CORP" value="STANDARD_CORP" />
                </el-select>
                <span style="font-size: 12px">{{ $t('mdfeTranslate.AzulCargoServiceLevelCode') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <!--货物性质-->
              <el-form-item
                :label="$t('mdfeTranslate.GoodsNature')"
                prop="transportConfig.produtoNatureza"
                :rules="[
                  { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur','change']}
                ]"
              >
                <el-select
                  v-model="form.transportConfig.produtoNatureza"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  style="width: 100%"
                  clearable
                  filterable
                >
                  <el-option key="1" label="NOR" value="NOR" />
                  <el-option key="2" label="UTILIDADES" value="UTILIDADES" />
                  <el-option key="3" label="ELETRONICOS" value="ELETRONICOS" />
                </el-select>
                <span style="font-size: 12px">{{ $t('mdfeTranslate.DescribeTheTypeOfGoodsBeingShipped') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <!--操作代码-->
              <el-form-item
                :label="$t('mdfeTranslate.OperationCode')"
                prop="transportConfig.codigoManuseio"
                :rules="[
                  { required: false, message: $t('collectionCenter.notNull'), trigger: ['blur','change']}
                ]"
              >
                <el-select
                  v-model="form.transportConfig.codigoManuseio"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  style="width: 100%"
                  clearable filterable
                >
                  <!--正常-->
                  <el-option key="1" :label="'NOR-' + $t('mdfeTranslate.Normal')" value="NOR" />
                  <!--易碎-->
                  <el-option key="2" :label="'VUN-' + $t('mdfeTranslate.Fragile')" value="VUN" />
                  <!--易腐-->
                  <el-option key="3" :label="'PER-' + $t('mdfeTranslate.EasyToRot')" value="PER" />
                </el-select>
                <span style="font-size: 12px">{{ $t('mdfeTranslate.SpecialRequirementsForHandlingGoods') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <!--产品代码-->
              <el-form-item
                :label="$t('mdfeTranslate.ProductCode')"
                prop="transportConfig.codigoProduto"
                :rules="[
                  { required: false, message: $t('collectionCenter.notNull'), trigger: ['blur','change']}
                ]"
              >
                <el-input
                  v-model="form.transportConfig.codigoProduto"
                  :placeholder="$t('GlobalSetObj.pleaseInput')"
                  clearable
                />
                <span style="font-size: 12px">{{ $t('mdfeTranslate.ItCanBeUsedForEnteringProductCodeTypes') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <!--是否现场取货-->
              <el-form-item
                :label="$t('mdfeTranslate.IsItPickedUpInTheField')"
                prop="transportConfig.taxaColeta"
                :rules="[
                  { required: false, message: $t('collectionCenter.notNull'), trigger: ['blur','change']}
                ]"
              >
                <el-switch
                  v-model="form.transportConfig.taxaColeta"
                  :active-text="$t('GlobalSetObj.yes')"
                  :inactive-text="$t('GlobalSetObj.No')"
                />
                <span style="font-size: 12px">{{ $t('mdfeTranslate.IndicateWhetherAzulIsToPickUp') }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
      </el-form>
    </div>
    <div style="padding: 20px;display: flex;border-top: 1px solid #ddd">
      <div v-if="formType !== 1" style="flex: 1">
        <el-checkbox
          v-model="isDraft"
          :label="$t('mdfeTranslate.LoadDraft')"
          @change="whetherLoadDraft"
        />
      </div>
      <div style="flex: 1;text-align: right">
        <el-button
          v-if="formType !== 1"
          size="small"
          @click="submitForm(1)"
        >{{ $t('collectionCenter.Stored') }}</el-button>
        <el-button
          v-if="formType !== 1"
          size="small"
          :loading="submitLoading"
          type="primary"
          @click="submitForm(2)"
        >{{ $t('collectionCenter.submit') }}</el-button>
        <el-button size="small" @click="closeWindow">{{ $t('collectionCenter.close') }}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { airlinePushConfigAdd, airlinePushConfigUpdate } from '@/api/invoiceCenter';

export default {
  name: 'Form',
  props: {
    formData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    formType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      form: {},
      submitLoading: false,
      isDraft: false
    };
  },
  watch: {
    formData: {
      handler(val) {
        this.form = val;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 支付方式更改
    changeFormaPagamento(val) {
      if (val === 'PX') {
        this.form.transportConfig.contaCorrente = '11605535000102';
      } else {
        this.form.transportConfig.contaCorrente = '';
      }
    },
    // 提交
    submitForm(type) {
      if (type === 2) {
        this.$refs.formDataRef.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            const formData = {
              airlineName: this.form.basicConfig.airlineName,
              configValue: JSON.stringify(this.form)
            };
            if (this.formType === 0) {
              airlinePushConfigAdd(formData).then(res => {
                if (res.code === 200) {
                  this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
                  this.$emit('closeUpdate', true);
                }
              }).finally(() => {
                this.submitLoading = false;
              });
            } else if (this.formType === 2) {
              formData.configCode = this.form.basicConfig.configCode;
              airlinePushConfigUpdate(formData).then(res => {
                if (res.code === 200) {
                  this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
                  this.$emit('closeUpdate', true);
                }
              }).finally(() => {
                this.submitLoading = false;
              });
            }
          }
        });
      } else {
        localStorage.setItem('airlinePushConfigForm', JSON.stringify(this.form));
        this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
      }
    },
    // 关闭
    closeWindow() {
      this.$emit('closeUpdate', false);
    },
    // 载入草稿
    whetherLoadDraft(val) {
      if (val) {
        const data = localStorage.getItem('airlinePushConfigForm');
        if (data) {
          this.form = JSON.parse(data);
        } else {
          this.$message.warning(this.$t('mdfeTranslate.NoDraftAvailable'));
        }
      } else {
        this.form = {
          basicConfig: {
            airlineName: null,
            baseUrl: null,
            email: null,
            senha: null
          },
          transportConfig: {
            formaPagamento: 'PX',
            contaCorrente: '11605535000102',
            tipoEntrega: 'Aeroporto',
            siglaServico: 'STANDARD',
            produtoNatureza: '',
            codigoProduto: 'NOR',
            codigoManuseio: 'NOR',
            taxaColeta: false
          }
        };
        this.$refs.formDataRef.resetFields();
      }
    }
  }
};
</script>

<style scoped>
.form-content {
  padding: 15px;
  height: calc(100vh - 145px);
  overflow-y:auto;
}
.form-content /deep/ .el-form-item__content {
  line-height: 20px !important;
}
.form-content /deep/ .el-input.is-disabled .el-input__inner,
.form-content /deep/ .el-textarea.is-disabled .el-textarea__inner {
  color: #5a6473;
}
</style>
